import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-manual-role-management',
  templateUrl: './manual-role-management.page.html',
  styleUrls: ['./manual-role-management.page.scss'],
})
export class ManualRoleManagementPage implements OnInit {

 
  @Input() public activerole: any;

  public appPages = [
    {
      title: "Search",
      url: "/role-management-data",
      icon: "mail",
      action: 1,
    },
    {
      title: "Data Detail",
      url: "/role-management-detail",
      icon: "paper-plane",
      action: 2,
    }
  ];

  constructor(public router: Router, public appService: AppService) {}

  ngOnInit() {
    // this.appService.active.subscribe((value) => {
    //   console.log("value...", value);
    //   this.activecustomer = value;
    // });
  }

  ionViewDidEnter(){
    this.appService.active.subscribe((value) => {
      console.log("value...", value);
      this.activerole = value;
    });
  }

  clickMenu(a) {
    this.appService.setActive(a);
    this.router.navigate([a.url]);

    // if (a.action === 1) {
    //   this.appService.setActive(a);
    //   this.router.navigate([a.url]);
    // }
    // if (a.action === 2) {
    //   this.appService.setActive(a);
    //   this.router.navigate([a.url]);
    // }
  }

}
